module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_recommended_articles-74cbf172442700a3f84410a8a0c7b90e.svg";